import { useContext } from "react";
import { LocalNetworkAccessContext } from "../providers/lna-context";

export function useLocalNetworkAccess() {
  return useContext(LocalNetworkAccessContext);
}
